var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.slickCarousel = function() {
	$('.slick-lead').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
		nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 60 30"><path d="M44.1,6.3l8.7,8.7l-8.7,8.7" fill="none"></path><path d="M7.1,15h44.4" fill="none"></path></svg></button>',
		prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 60 30"><path class="st0" d="M15.9,23.7L7.1,15l8.7-8.7" fill="none"></path><path class="st1" d="M52.9,15H8.5" fill="none"></path></svg></button>',
	});
}();

FIGURE.downArrow = function() {
	if ($(".title-arrow").length) {
		$(window).on("load scroll", e => {
			if ($(window).scrollTop() > 30) {
				$(".title-arrow").hide(300);
				$(".title-arrow").addClass("hide");
			} else {
				$(".title-arrow").show(300);
				$(".title-arrow").removeClass("hide");
			}
		});
	}
}();